// extracted by mini-css-extract-plugin
export default {"disclaimers":"style_disclaimers__AghzW","disclaimers__item":"style_disclaimers__item__Lgd9O"};